module.exports = __webpack_public_path__ + "static/Fleet-Management-4f0b00b447a58c1fe71f6135f24e6406.jpg";